"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var ImportTypeEnum;
(function (ImportTypeEnum) {
    ImportTypeEnum["Client"] = "client";
    ImportTypeEnum["PremierCore"] = "premier_core";
    ImportTypeEnum["AppointmentType"] = "appointment_type";
    ImportTypeEnum["SessionType"] = "session_type";
    ImportTypeEnum["AreaBookingType"] = "area_booking_type";
    ImportTypeEnum["RetailProduct"] = "retail_product";
    ImportTypeEnum["Package"] = "package";
    ImportTypeEnum["InventoryProduct"] = "inventory_product";
})(ImportTypeEnum = exports.ImportTypeEnum || (exports.ImportTypeEnum = {})); /**
* @export
* @enum {string}
*/
var ImportStatusEnum;
(function (ImportStatusEnum) {
    ImportStatusEnum["Validating"] = "validating";
    ImportStatusEnum["Validated"] = "validated";
    ImportStatusEnum["Importing"] = "importing";
    ImportStatusEnum["Imported"] = "imported";
    ImportStatusEnum["RollingBack"] = "rolling_back";
    ImportStatusEnum["RolledBack"] = "rolled_back";
    ImportStatusEnum["Errored"] = "errored";
})(ImportStatusEnum = exports.ImportStatusEnum || (exports.ImportStatusEnum = {}));
function ImportFromJSON(json) {
    return ImportFromJSONTyped(json, false);
}
exports.ImportFromJSON = ImportFromJSON;
function ImportFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'status': json['status'],
        'total_rows': json['total_rows'],
        'imported_rows': json['imported_rows'],
        'failed_validation_rows': json['failed_validation_rows'],
        'failed_import_rows': json['failed_import_rows'],
        'premier_core_mapping_id': !runtime_1.exists(json, 'premier_core_mapping_id') ? undefined : json['premier_core_mapping_id'],
        'created_at': (new Date(json['created_at'])),
        'updated_at': (new Date(json['updated_at'])),
        'validated_at': !runtime_1.exists(json, 'validated_at') ? undefined : (json['validated_at'] === null ? null : new Date(json['validated_at'])),
        'imported_at': !runtime_1.exists(json, 'imported_at') ? undefined : (json['imported_at'] === null ? null : new Date(json['imported_at'])),
        'rolled_back_at': !runtime_1.exists(json, 'rolled_back_at') ? undefined : (json['rolled_back_at'] === null ? null : new Date(json['rolled_back_at'])),
        'progress': json['progress'],
        'created_by': _1.TrybeUserSummaryFromJSON(json['created_by']),
    };
}
exports.ImportFromJSONTyped = ImportFromJSONTyped;
function ImportToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': value.type,
        'status': value.status,
        'total_rows': value.total_rows,
        'imported_rows': value.imported_rows,
        'failed_validation_rows': value.failed_validation_rows,
        'failed_import_rows': value.failed_import_rows,
        'premier_core_mapping_id': value.premier_core_mapping_id,
        'created_at': (value.created_at.toISOString()),
        'updated_at': (value.updated_at.toISOString()),
        'validated_at': value.validated_at === undefined ? undefined : (value.validated_at === null ? null : value.validated_at.toISOString()),
        'imported_at': value.imported_at === undefined ? undefined : (value.imported_at === null ? null : value.imported_at.toISOString()),
        'rolled_back_at': value.rolled_back_at === undefined ? undefined : (value.rolled_back_at === null ? null : value.rolled_back_at.toISOString()),
        'progress': value.progress,
        'created_by': _1.TrybeUserSummaryToJSON(value.created_by),
    };
}
exports.ImportToJSON = ImportToJSON;
